import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-crop",
  "use": "svgIcon-crop-usage",
  "viewBox": "0 0 533.333 533.333",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 533.333 533.333\" id=\"svgIcon-crop\"><path d=\"M433 133L533 33 500 0 400 100H167V0h-67v100H0v67h100v267h267v100h67V434h100v-67H434V134m-267 33h167L167 334V167m33 200l167-167v167H200\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol